var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import Users from '../ui/views/users';
import Cases from '../ui/views/cases';
import CaseDetails from '../ui/views/caseDetails';
import AutoSearch from '../ui/views/autoSearch';
import { URL_ROUTE } from '../shared/constants';
import ApiCheck from 'src/ui/views/apiCheck';
export var E_ROUTE_KEY;
(function (E_ROUTE_KEY) {
    E_ROUTE_KEY["CASES"] = "cases";
    E_ROUTE_KEY["USERS"] = "users";
    E_ROUTE_KEY["CASE_DETAIL"] = "caseDetails";
    E_ROUTE_KEY["API_CHECK"] = "apiCheck";
    E_ROUTE_KEY["AUTO_SEARCH"] = "autoSearch";
})(E_ROUTE_KEY || (E_ROUTE_KEY = {}));
export var routes = (_a = {},
    _a[E_ROUTE_KEY.CASES] = { path: URL_ROUTE.CASES, element: _jsx(Cases, {}), protected: true },
    _a[E_ROUTE_KEY.USERS] = { path: URL_ROUTE.USERS, element: _jsx(Users, {}), protected: true },
    _a[E_ROUTE_KEY.CASE_DETAIL] = { path: URL_ROUTE.CASE_DETAIL, element: _jsx(CaseDetails, {}), protected: true },
    _a[E_ROUTE_KEY.API_CHECK] = { path: URL_ROUTE.API_CHECK, element: _jsx(ApiCheck, {}), protected: false },
    _a[E_ROUTE_KEY.AUTO_SEARCH] = { path: URL_ROUTE.AUTO_SEARCH, element: _jsx(AutoSearch, {}), protected: true },
    _a);
